import { render, staticRenderFns } from "./Expectedposition.vue?vue&type=template&id=557281f9&scoped=true"
import script from "./Expectedposition.vue?vue&type=script&lang=js"
export * from "./Expectedposition.vue?vue&type=script&lang=js"
import style0 from "./Expectedposition.vue?vue&type=style&index=0&id=557281f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557281f9",
  null
  
)

export default component.exports